import "../styles/style.css";
import "htmx.org";
import Swiper from "swiper";
import {
  Navigation,
  Pagination,
  Autoplay,
  EffectFade,
  Thumbs,
  FreeMode,
} from "swiper/modules";

// Import Swiper styles
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "swiper/css/effect-fade";

document.addEventListener("DOMContentLoaded", () => {
  // 1. Initializar Main Banner Swiper
  const mainBanner = new Swiper(".main-banner", {
    modules: [Navigation, Autoplay, EffectFade],
    loop: true,
    effect: "fade",
    speed: 1000,
    autoplay: {
      delay: 5000,
      disableOnInteraction: false,
    },
  });

  mainBanner.on("slideChange", () => {
    updateBannerThumbs(mainBanner.realIndex);
  });
  updateBannerThumbs(mainBanner.realIndex);

  // Banner Thumbs Navigation
  function updateBannerThumbs(activeIndex: number) {
    const thumbs =
      document.querySelectorAll<HTMLButtonElement>(".banner-thumb");
    thumbs.forEach((thumb) => {
      const idx = parseInt(thumb.dataset.slideIndex || "0", 10);
      if (idx === activeIndex) {
        thumb.classList.add("border-violet-500", "shadow-md", "scale-105");
        thumb.classList.remove("border-transparent");
      } else {
        thumb.classList.remove("border-violet-500", "shadow-md", "scale-105");
        thumb.classList.add("border-transparent");
      }
    });
  }

  const bannerThumbs =
    document.querySelectorAll<HTMLButtonElement>(".banner-thumb");
  bannerThumbs.forEach((thumb) => {
    thumb.addEventListener("click", () => {
      const idx = parseInt(thumb.dataset.slideIndex || "0", 10);
      mainBanner.slideToLoop(idx);
    });
  });

  // 2. Initializar Promotions Swiper
  const promoSliders = document.querySelectorAll(".promotions-swiper");
  promoSliders.forEach((el) => {
    new Swiper(el as HTMLElement, {
      modules: [Navigation, Pagination, Autoplay],
      slidesPerView: 1,
      spaceBetween: 30,
      loop: true,
      autoplay: {
        delay: 5000,
        disableOnInteraction: false,
      },
      navigation: {
        nextEl: el.querySelector(".promo-next") as HTMLElement,
        prevEl: el.querySelector(".promo-prev") as HTMLElement,
      },
      pagination: {
        el: el.querySelector(".promo-pagination") as HTMLElement,
        clickable: true,
      },
    });
  });

  // 3. Initializar Testimonials Swiper
  const testimonialSliders = document.querySelectorAll(".testimonials-swiper");
  testimonialSliders.forEach((el) => {
    new Swiper(el as HTMLElement, {
      modules: [Navigation, Pagination, Autoplay],
      slidesPerView: 1,
      spaceBetween: 30,
      loop: true,
      autoplay: {
        delay: 6000,
        disableOnInteraction: true,
      },
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
      pagination: {
        el: ".testimonials-pagination",
        clickable: true,
      },
      breakpoints: {
        1024: {
          slidesPerView: 2,
        },
      },
    });
  });

  // Services Swiper
  const servicesSliders = document.querySelectorAll(".services-swiper");
  servicesSliders.forEach((el) => {
    new Swiper(el as HTMLElement, {
      modules: [Navigation, Pagination, Autoplay],
      slidesPerView: 1,
      spaceBetween: 30,
      loop: true,
      autoplay: {
        delay: 5000,
        disableOnInteraction: false,
      },
      navigation: {
        nextEl: ".services-next",
        prevEl: ".services-prev",
      },
      breakpoints: {
        640: {
          slidesPerView: 2,
        },
        1024: {
          slidesPerView: 3,
        },
      },
    });
  });

  // 4. Product Gallery Swiper (Single Product)
  const thumbsSwiper = new Swiper(".product-gallery-thumbs", {
    spaceBetween: 10,
    slidesPerView: 4,
    freeMode: true,
    watchSlidesProgress: true,
    modules: [Navigation, Pagination, Autoplay, FreeMode],
  });

  new Swiper(".product-gallery-main", {
    spaceBetween: 10,
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
    thumbs: {
      swiper: thumbsSwiper,
    },
    modules: [Navigation, Pagination, Autoplay, EffectFade, Thumbs], // Ensure modules are passed
  });

  // 4. Scroll Animations Trigger (Intersection Observer)
  const animateOnScroll = () => {
    const observerOptions = {
      root: null,
      rootMargin: "0px",
      threshold: 0.1,
    };

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          const target = entry.target as HTMLElement;
          const animationClass = target.dataset.animate;
          if (animationClass) {
            target.classList.add(...animationClass.split(" "));
            observer.unobserve(target);
          }
        }
      });
    }, observerOptions);

    document.querySelectorAll("[data-animate]").forEach((el) => {
      observer.observe(el);
    });
  };

  animateOnScroll();

  // 5. Modal Backdrop Click Close
  document.querySelectorAll("dialog").forEach((dialog) => {
    dialog.addEventListener("click", (e) => {
      const rect = dialog.getBoundingClientRect();
      const isInDialog =
        rect.top <= e.clientY &&
        e.clientY <= rect.top + rect.height &&
        rect.left <= e.clientX &&
        e.clientX <= rect.left + rect.width;
      if (!isInDialog) {
        dialog.close();
      }
    });
  });

  // 6. Floating Sticky Card Logic
  const bannerSection = document.querySelector(".main-banner");

  if (bannerSection) {
    // Check if we have any card triggers in the DOM (meaning we are on a single service page)
    const hasCards = document.querySelector(".banner-float-card");
    if (!hasCards) return;

    // Create the floating container if it doesn't exist
    let stickyBtn = document.getElementById("sticky-form-trigger");
    if (!stickyBtn) {
      stickyBtn = document.createElement("div");
      stickyBtn.id = "sticky-form-trigger";
      stickyBtn.className =
        "fixed bottom-6 right-6 z-40 transition-all duration-500 transform translate-y-24 opacity-0 pointer-events-none";
      stickyBtn.innerHTML = `
        <div class="bg-white p-4 rounded-xl shadow-2xl border border-brand-purple/20 cursor-pointer hover:scale-105 transition-transform flex items-center gap-3">
            <div class="w-10 h-10 rounded-full bg-brand-purple text-white flex items-center justify-center shrink-0">
                <svg class="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z" />
                </svg>
            </div>
            <div class="flex flex-col">
                <span class="font-bold text-gray-900 text-sm leading-tight">Cotizar Ahora</span>
                <span class="text-xs text-brand-purple font-medium">Click aquí</span>
            </div>
        </div>
      `;
      document.body.appendChild(stickyBtn);

      // On click, trigger the modal of the ACTIVE slide
      stickyBtn.addEventListener("click", () => {
        const activeSlide = document.querySelector(".swiper-slide-active");
        if (activeSlide) {
          const cardTrigger = activeSlide.querySelector(".banner-float-card");
          if (cardTrigger) {
            const modalId = cardTrigger.getAttribute("data-modal-target");
            if (modalId) {
              const modal = document.getElementById(
                modalId,
              ) as HTMLDialogElement;
              modal?.showModal();
            }
          }
        }
      });
    }

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (!entry.isIntersecting && entry.boundingClientRect.top < 0) {
          // Scrolled past banner
          stickyBtn?.classList.remove(
            "translate-y-24",
            "opacity-0",
            "pointer-events-none",
          );
        } else {
          // In banner view
          stickyBtn?.classList.add(
            "translate-y-24",
            "opacity-0",
            "pointer-events-none",
          );
        }
      },
      { threshold: 0 },
    );

    observer.observe(bannerSection);
  }

  // 7. Handle clicks on links with href="#form" (only on service pages)
  document.addEventListener("click", (e) => {
    const target = (e.target as HTMLElement).closest('a[href="#form"]');
    if (target) {
      e.preventDefault();

      // Check if we are on a service page (has banner cards)
      const hasCards = document.querySelector(".banner-float-card");
      if (!hasCards) return;

      // Try to find the active slide modal trigger
      const activeSlide = document.querySelector(".swiper-slide-active");
      if (activeSlide) {
        const cardTrigger = activeSlide.querySelector(".banner-float-card");
        if (cardTrigger) {
          const modalId = cardTrigger.getAttribute("data-modal-target");
          if (modalId) {
            const modal = document.getElementById(modalId) as HTMLDialogElement;
            if (modal) {
              modal.showModal();
            }
          }
        }
      }
    }
  });

  // 8. Sticky Banner Card Logic (Disabled by user request - make it static)
  const bannerStickySection = document.getElementById("banner-section");
  // const bannerStickyCard = document.getElementById("banner-card");

  // 9. Mobile Card Modal & CTA Bar Logic
  const mobileModal = document.getElementById(
    "mobile-card-modal",
  ) as HTMLDialogElement;
  const openMobileModalBtn = document.getElementById("open-mobile-modal");
  const closeMobileModalBtn = document.getElementById("close-mobile-modal");
  const mobileCtaBar = document.getElementById("mobile-cta-bar");

  if (mobileModal && openMobileModalBtn) {
    openMobileModalBtn.addEventListener("click", () => {
      mobileModal.showModal();
      document.body.style.overflow = "hidden"; // Prevent scroll behind
    });

    closeMobileModalBtn?.addEventListener("click", () => {
      mobileModal.close();
      document.body.style.overflow = ""; // Restore scroll
    });

    mobileModal.addEventListener("close", () => {
      document.body.style.overflow = "";
    });
  }

  // Hide mobile CTA bar while banner is visible
  if (mobileCtaBar && bannerStickySection) {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (!entry.isIntersecting && entry.boundingClientRect.top < 0) {
          mobileCtaBar.classList.remove("translate-y-full", "opacity-0");
          mobileCtaBar.classList.add("translate-y-0", "opacity-100");
        } else {
          mobileCtaBar.classList.add("translate-y-full", "opacity-0");
          mobileCtaBar.classList.remove("translate-y-0", "opacity-100");
        }
      },
      { threshold: 0.1 },
    );

    observer.observe(bannerStickySection);
  }

  // 10. Header Scroll Effect
  const mainHeader = document.getElementById("main-header");
  const headerLogo = document.getElementById("header-logo");
  const headerContainer = mainHeader?.querySelector("a");

  if (mainHeader && headerLogo) {
    window.addEventListener("scroll", () => {
      if (window.scrollY > 50) {
        mainHeader.classList.add(
          "bg-primary/95",
          "backdrop-blur-md",
          "shadow-lg",
        );
        headerLogo.classList.remove("lg:h-16");
        headerLogo.classList.add("h-8", "lg:h-10");
        headerContainer?.classList.remove("py-4");
        headerContainer?.classList.add("py-2");
      } else {
        mainHeader.classList.remove(
          "bg-primary/95",
          "backdrop-blur-md",
          "shadow-lg",
        );
        headerLogo.classList.add("lg:h-16");
        headerLogo.classList.remove("h-8", "lg:h-10");
        headerContainer?.classList.add("py-4");
        headerContainer?.classList.remove("py-2");
      }
    });
  }
});
